import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    input: {
        display: 'none'
    },
    inputField: {
        '& .MuiTextField-root': {
            width: '40ch',
        },
    },
    textMessageInputField: {
        '& .MuiTextField-root': {
            width: '80ch',
        },
    },
    loader: {
        height: 45
    }
}));

const TextMessagingStartSingle = () => {
    useEffect(() => {
        document.title = 'Send Single Text Message';
        getPhoneNumbers();
    }, []);

    const [phoneNumbers, setPhoneNumbers] = useState([]);

    const getPhoneNumbers = () => {
        fetch('/admin/sms/phone-numbers', { method: 'GET' })
        .then(response => {
            return response.json();
        })
        .then(result => {
            setPhoneNumbers(result);
            setSelectedPhoneNumber(result[0].id);
        })
        .catch(reason => {
            alert('An error prevented getting phone number senders.');
        })
    };

    const classes = useStyles();
    const history = useHistory();
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [messageField, setMessageField] = useState('');
    const [recipientField, setRecipientField] = useState('');

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleCancel = () => {
        history.push('/admin/sms');
    }

    const handleMessageChange = (event) => {
        setMessageField(event.target.value);
    }

    const handleRecipientChange = (event) => {
        setRecipientField(event.target.value);
    }

    const handlePhoneNumberChange = (event) => {
        setSelectedPhoneNumber(event.target.value);
    }

    const handleSubmit = () => {
        if (!messageField || !recipientField) {
            alert('Missing one of the following: text message, recipient phone number');
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append('_token', window._token);
        // formData.append('phoneNumberId', selectedPhoneNumber); // Not yet needed or used for admin/sms/send endpoint
        formData.append('messageField', messageField);
        formData.append('recipient', recipientField);

        let url = `/admin/sms/send`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (response.status === 403) {
                setLoading(false);
                alert('Cannot send to recipient who has blocked SMS messages.');
            } else {
                return response.json();
            }
        })
        .then(result => {
            if (result) {
                setLoading(false);
                setMessageField('');
                setSnackbarMessage('Successfully sent message');
                setOpenSnackbar(true);
            }
        })
        .catch(reason => {
            console.log(reason);
            setLoading(false);
            alert('An error prevented submitting. Please try again.');
        })
    }

    return (
        <Paper square className={classes.paper}>
            <Typography variant="h6">Text Messaging</Typography>
            <Box className={classes.inputField}>
                <Box mt={2} mb={1}>
                    <Typography variant="subtitle2">Set Phone Number for Sender</Typography>
                </Box>
                <TextField
                    value={selectedPhoneNumber}
                    onChange={handlePhoneNumberChange}
                    select
                    helperText="This is the sender phone number"
                    variant="outlined"
                >
                    {phoneNumbers && phoneNumbers.length > 0 && (
                        phoneNumbers.map((option, index) => (
                            <MenuItem value={option.id} key={`phonenumber-${index}`}>{option.friendly_name}</MenuItem>
                        ))
                    )}
                    {!phoneNumbers && <MenuItem>---</MenuItem>}
                </TextField>
            </Box>
            <Box className={classes.textMessageInputField}>
                <Box mt={2} mb={1}>
                    <Typography variant="subtitle2">Recipient Phone Number</Typography>
                </Box>
                <TextField
                    value={recipientField}
                    onChange={handleRecipientChange}
                    placeholder="Enter phone number"
                    variant="outlined"
                />
            </Box>
            <Box className={classes.textMessageInputField}>
                <Box mt={2} mb={1}>
                    <Typography variant="subtitle2">SMS Message</Typography>
                </Box>
                <TextField
                    value={messageField}
                    onChange={handleMessageChange}
                    placeholder="Enter text message"
                    variant="outlined"
                    multiline
                    rows={8}
                />
            </Box>
            <Box mt={2} display="flex">
                <Button disabled={!messageField || !recipientField || !selectedPhoneNumber || loading} variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                <Box ml={1}>
                    <Button disabled={loading} variant="outlined" onClick={handleCancel}>Back</Button>
                </Box>
            </Box>
            <Box mt={2} className={classes.loader}>
                {loading && <CircularProgress color="primary" />}
            </Box>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={openSnackbar}
                autoHideDuration={8000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </Paper>
    );
}

export default TextMessagingStartSingle;
